
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.85002 0.150391V0.667057L4.00002 0.817057H8.00002L8.15002 0.667057V0.150391H9.18302L9.18336 0.667057L9.33336 0.817057L11.85 0.816391V11.8504H0.150024V0.816391L2.66669 0.817057L2.81669 0.667057L2.81602 0.150391H3.85002ZM10.6667 5.18372H1.33336L1.18336 5.33372V10.6671L1.33336 10.8171H10.6667L10.8167 10.6671V5.33372L10.6667 5.18372ZM1.33336 1.85039H2.66669L2.81669 2.00039L2.81602 2.51639H3.85002V2.00039L4.00002 1.85039H8.00002L8.15002 2.00039V2.51639H9.18302L9.18336 2.00039L9.33336 1.85039H10.6667L10.8167 2.00039V4.00039L10.6667 4.15039H1.33336L1.18336 4.00039V2.00039L1.33336 1.85039Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Date',
    }) as DefineComponent
    </script>
    